import { defineComponent as _defineComponent } from 'vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilterLinkOrganism',
  props: {
    facetId: null,
    options: null
  },
  setup: function setup(__props) {
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    return {
      __sfc: true,
      app: app,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});